@if (form) {
    @if (
        !readonlyMode &&
        auditMode === AuditMode.Off &&
        formStylingOptions?.actionButtonPosition === 'top'
    ) {
        <div
            class="form-action-buttons px-4 py-2 active-component d-flex align-items-center"
            [class.justify-content-center]="formStylingOptions?.hideStatus"
            data-cy="form-framework-action-button-banner-top"
        >
            <ng-container *ngTemplateOutlet="actionButtonBanner"></ng-container>
        </div>
    }
    @if (layoutError && !validationSummary?.length) {
        <wdx-alert
            class="m-2"
            themeColor="danger"
            data-cy="ff-layout-error-alert"
            >{{
                FORM_FRAMEWORK_LAYOUT_ERROR | translateTokenisedString
            }}</wdx-alert
        >
    }
    @if (auditMode === AuditMode.Off) {
        <div
            class="form-container flex-grow-1 overflow-hidden"
            [class.visually-hidden]="showFormHistory"
            [wdxIsLoading]="!!isSaving"
            [loadingOverlay]="true"
        >
            @if (hasError) {
                <p class="h6">
                    {{ SOMETHING_WENT_WRONG | translateTokenisedString }}
                </p>
            }
            <div class="h-100 d-flex flex-column overflow-hidden">
                <div
                    class="d-flex flex-column form-framework__messages-container"
                >
                    @if (form?.invalid && $any(validationSummary?.length) > 0) {
                        @if (submitAttempted) {
                            <wdx-ff-validation-summary
                                class="d-block mb-2 form-framework__validation-messages"
                                data-cy="lbl-message"
                                [message]="validationMessage"
                                [validationSummary]="validationSummary"
                                (errorClicked)="onErrorClicked($event)"
                            >
                                @if (saveDraftMode) {
                                    <button
                                        class="text-nowrap ms-2"
                                        data-cy="btn-save-draft"
                                        [wdxButton]="
                                            WdxButtonStyle.OutlinePrimary
                                        "
                                        (click)="onDraftSaveClick()"
                                    >
                                        {{
                                            SAVE_AS_DRAFT_BTN
                                                | translateTokenisedString
                                        }}
                                    </button>
                                }
                            </wdx-ff-validation-summary>
                        }
                    }
                    @if (formData?.pendingChanges?.length) {
                        <wdx-ff-pending-changes
                            class="overflow-auto"
                            data-cy="pending-changes"
                            [showButton]="false"
                            [pendingChanges]="
                                $any(formPendingChangesService?.coc)
                            "
                            [pendingChangesSubForm]="
                                $any(
                                    formPendingChangesService?.pendingChangesSubFormCounter
                                )
                            "
                        ></wdx-ff-pending-changes>
                    }
                    @if (messageDefinitionLength) {
                        <wdx-alert
                            class="remove-margin-bottom"
                            themeColor="warning"
                        >
                            <wdx-icon
                                class="pe-3 align-self-start"
                                icon="info-circle"
                            ></wdx-icon>
                            @for (
                                messageDefinition of messageDefinition
                                    | keyvalue;
                                track messageDefinition.key
                            ) {
                                <span
                                    [innerHTML]="
                                        $any(messageDefinition?.value)?.label
                                            | translateTokenisedString
                                            | markdownToHtml
                                            | safeHtml
                                    "
                                ></span>
                            }
                        </wdx-alert>
                    }
                    @if (showFormSwitcherPanel) {
                        <wdx-ff-version-info>
                            <ng-container
                                *ngTemplateOutlet="formVersionInfo"
                            ></ng-container>
                        </wdx-ff-version-info>
                    }
                    @if (
                        formData?.context?.activityExternalTask
                            ?.externalStatus ===
                        ExternalTaskStatusType.Submitted
                    ) {
                        <wdx-alert themeColor="warning">{{
                            FORM_EXTERNAL_USER_FORM_DATA_CHANGES
                                | translateTokenisedString
                                    : {
                                          dataName:
                                              formData?.context
                                                  ?.externalFormSummary
                                                  ?.lastUpdatedByParty?.name ||
                                              '',
                                      }
                        }}</wdx-alert>
                    }
                    @if (formData?.lock) {
                        <div>
                            <wdx-ff-lock-summary
                                [formData]="formData"
                            ></wdx-ff-lock-summary>
                        </div>
                    }
                    @if (infoCards$ | ngrxPush; as summaryInfoCards) {
                        @if (summaryInfoCards.length) {
                            <div class="border-bottom">
                                <wdx-ff-summary-info-cards
                                    [infoCards]="summaryInfoCards"
                                ></wdx-ff-summary-info-cards>
                            </div>
                        }
                    }
                </div>
                <form
                    class="form flex-grow-1 overflow-hidden"
                    autocomplete="off"
                    [formGroup]="form"
                    data-cy="ff-form"
                    (click)="formElementClicked($event)"
                >
                    <div class="d-block h-100 overflow-auto scroll-smooth">
                        <div
                            ngbAccordion
                            #accordion
                            class="accordion form-accordion accordion-flush"
                            [destroyOnHide]="false"
                            [closeOthers]="false"
                        >
                            @let layoutAndDef = layoutAndDefinition$ | ngrxPush;
                            @let layoutAndDefLength = layoutAndDef?.length ?? 0;
                            @for (
                                formSectionLayoutDefinition of layoutAndDef;
                                track formSectionLayoutDefinition?.section
                                    ?.name;
                                let i = $index;
                                let first = $first
                            ) {
                                @if (
                                    !formSectionLayoutDefinition?.section
                                        ?.isHidden
                                ) {
                                    <div
                                        [class.d-none]="
                                            hiddenSections && hiddenSections
                                                | arrayIncludes: i
                                        "
                                        [ngbAccordionItem]="
                                            'reactive-form-' + i
                                        "
                                        [ngClass]="
                                            'form-section border-bottom-0' +
                                            (formStylingOptions?.background ===
                                            'muted'
                                                ? ' bg-muted'
                                                : '') +
                                            (first ? '' : ' mt-1') +
                                            (layoutAndDefLength > 1
                                                ? ''
                                                : ' no-panel-toggle')
                                        "
                                        [collapsed]="
                                            !(
                                                activePanelIds || []
                                                | arrayIncludes
                                                    : 'reactive-form-' + i
                                            )
                                        "
                                    >
                                        <div ngbAccordionHeader aria-level="2">
                                            @if (layoutAndDefLength > 0) {
                                                <button
                                                    ngbAccordionButton
                                                    [class.d-none]="
                                                        layoutAndDefLength ===
                                                            1 ||
                                                        !!hiddenSections?.length
                                                    "
                                                    class="form-section__header accordion-header accordion-button d-flex align-items-center bg-muted"
                                                    [attr.data-cy]="
                                                        'panel-toggle-' +
                                                        formSectionLayoutDefinition
                                                            .section?.name
                                                    "
                                                >
                                                    <div
                                                        class="d-flex align-items-center flex-grow-1"
                                                    >
                                                        <span class="h6">
                                                            {{
                                                                formSectionLayoutDefinition
                                                                    .section
                                                                    ?.label
                                                                    | translateTokenisedString
                                                            }}
                                                        </span>
                                                        @if (
                                                            submitAttempted &&
                                                            sectionsInError?.includes(
                                                                $any(
                                                                    formSectionLayoutDefinition
                                                                        .section
                                                                        ?.name
                                                                )
                                                            )
                                                        ) {
                                                            <wdx-icon
                                                                class="text-danger ms-2"
                                                                icon="exclamation-triangle"
                                                            >
                                                            </wdx-icon>
                                                        }
                                                    </div>
                                                </button>
                                            }
                                        </div>
                                        <div ngbAccordionCollapse>
                                            <div
                                                ngbAccordionBody
                                                class="form-section__body"
                                            >
                                                <ng-template>
                                                    @if (
                                                        formSectionLayoutDefinition
                                                            .section
                                                            ?.guidanceText
                                                    ) {
                                                        <p
                                                            class="form-section__body__blurb h6 small"
                                                        >
                                                            {{
                                                                formSectionLayoutDefinition
                                                                    .section
                                                                    ?.guidanceText
                                                                    | translateTokenisedString
                                                            }}
                                                        </p>
                                                    }
                                                    @if (
                                                        formSectionLayoutDefinition
                                                            ?.section
                                                            ?.customContent
                                                    ) {
                                                        <ng-container
                                                            *ngTemplateOutlet="
                                                                customSectionTmpl;
                                                                context: formSectionLayoutDefinition.section
                                                            "
                                                        ></ng-container>
                                                    } @else {
                                                        <div
                                                            class="form-section__body__fields form__fields grid"
                                                        >
                                                            @for (
                                                                elementDefinition of formSectionLayoutDefinition.layoutAndDefinition;
                                                                track elementDefinition.name;
                                                                let iLayout = $index
                                                            ) {
                                                                @if (
                                                                    !elementDefinition.isHidden &&
                                                                    (elementDefinition.elementType ||
                                                                        elementDefinition.fieldType)
                                                                ) {
                                                                    @if (
                                                                        elementDefinition.forcesNewRow &&
                                                                        !elementDefinition.forcesFullWidth
                                                                    ) {
                                                                        <div
                                                                            class="g-col-12"
                                                                        ></div>
                                                                    }
                                                                    <div
                                                                        class="g-col-12 input form-input mb-1"
                                                                        [class.g-col-lg-6]="
                                                                            !elementDefinition.forcesFullWidth &&
                                                                            elementDefinition.fieldType !==
                                                                                FormFieldType.Address &&
                                                                            (!elementDefinition.forcesNewRow ||
                                                                                !elementDefinition.forcesFullWidth)
                                                                        "
                                                                        [attr.data-cy]="
                                                                            'lbl-' +
                                                                            elementDefinition.name
                                                                        "
                                                                        [attr.data-form-control]="
                                                                            elementDefinition.name
                                                                        "
                                                                    >
                                                                        @if (
                                                                            ARRAY_CONTROL_TYPES
                                                                                | arrayIncludes
                                                                                    : elementDefinition?.fieldType
                                                                        ) {
                                                                            @if (
                                                                                elementDefinition
                                                                                    ?.children?.[0]
                                                                                    ?.section
                                                                                    ?.guidanceText
                                                                            ) {
                                                                                <p
                                                                                    class="form-section__body__blurb h6 small"
                                                                                >
                                                                                    {{
                                                                                        elementDefinition
                                                                                            ?.children?.[0]
                                                                                            ?.section
                                                                                            ?.guidanceText
                                                                                    }}
                                                                                </p>
                                                                            }
                                                                            <wdx-ff-form-array
                                                                                [entityId]="
                                                                                    entityId
                                                                                "
                                                                                [formArrayName]="
                                                                                    $any(
                                                                                        elementDefinition.name
                                                                                    )
                                                                                "
                                                                                [elementDefinition]="
                                                                                    elementDefinition
                                                                                "
                                                                                [formContext]="
                                                                                    formData?.context
                                                                                "
                                                                                [parentData]="
                                                                                    formData.data
                                                                                "
                                                                                [readonlyMode]="
                                                                                    readonlyMode
                                                                                "
                                                                                (formEvent)="
                                                                                    formEvent.emit(
                                                                                        $event
                                                                                    )
                                                                                "
                                                                            ></wdx-ff-form-array>
                                                                        } @else {
                                                                            <wdx-ff-controls-container
                                                                                class="h-100"
                                                                                [entityId]="
                                                                                    entityId
                                                                                "
                                                                                [formElement]="
                                                                                    elementDefinition
                                                                                "
                                                                                [formContext]="
                                                                                    formData?.context
                                                                                "
                                                                                (formEvent)="
                                                                                    formEvent.emit(
                                                                                        $event
                                                                                    )
                                                                                "
                                                                            ></wdx-ff-controls-container>
                                                                        }
                                                                    </div>
                                                                }
                                                            }
                                                        </div>
                                                    }
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                }
                            }
                        </div>
                        @if (
                            !readonlyMode &&
                            formStylingOptions?.actionButtonPosition ===
                                'bottom'
                        ) {
                            <div
                                class="form-action-buttons px-4 py-2 d-flex align-items-center"
                                [class.justify-content-center]="
                                    formStylingOptions?.hideStatus
                                "
                                data-cy="form-framework-action-button-banner-bottom"
                            >
                                <ng-container
                                    *ngTemplateOutlet="actionButtonBanner"
                                ></ng-container>
                            </div>
                        }
                    </div>
                </form>
                <ng-template #formVersionInfo>
                    <div>
                        {{
                            FORM_INFO_YOU_ARE_VIEWING | translateTokenisedString
                        }}
                        <span class="fw-bold">{{ formData.status }}</span>
                        {{ VERSION_OF_THIS_FORM | translateTokenisedString }}
                        ({{ BY | translateTokenisedString }}
                        <button
                            [wdxButton]="WdxButtonStyle.Link"
                            (click)="
                                openLinkInNewTab(
                                    $any(
                                        formData?.context?.lastUpdatedBy
                                            ?.partyType
                                    ),
                                    $any(formData?.context?.lastUpdatedBy?.id)
                                )
                            "
                        >
                            {{
                                formData?.lastUpdatedBy || 'unknown user'
                            }}</button
                        >,
                        {{
                            $any(formData?.lastUpdatedOn)
                                | displayDate: { relative: true }
                        }}) -
                        <button
                            [wdxButton]="WdxButtonStyle.Link"
                            (click)="switchFormVersion()"
                        >
                            {{ CLICK_HERE_BTN | translateTokenisedString }}
                            {{
                                formData.status === FORM_DATA_STATUS.Draft
                                    ? 'previously saved'
                                    : 'draft'
                            }}
                            {{
                                CLICK_TO_VIEW_VERSION_BTN
                                    | translateTokenisedString
                            }}
                        </button>
                    </div>
                </ng-template>
            </div>
        </div>
    }
    @if (showFormHistory || auditMode === AuditMode.DiffOnly) {
        <wdx-ff-form-history
            class="flex-grow-1 overflow-hidden"
            [title]="formLayout?.label | translateTokenisedString"
            [formId]="formId"
            [entityId]="entityId"
        ></wdx-ff-form-history>
    }
}

<ng-template #actionButtonBanner>
    @if (!formStylingOptions?.hideStatus && entityId && appId) {
        <div class="fw-bold me-2" data-cy="form-completion-info">
            @if (completionSummary?.expected) {
                {{ completionSummary?.completed }}
                {{ OF_LABEL | translateTokenisedString }}
                {{ completionSummary?.expected }}
                {{ FIELDS_COMPLETED | translateTokenisedString }}
            } @else {
                {{ NO_REQUIRED_FIELDS | translateTokenisedString }}
            }
        </div>
    }
    <div
        class="d-flex align-items-center"
        [class.ms-auto]="!formStylingOptions?.hideStatus"
    >
        @if (
            !formStylingOptions?.hideStatus &&
            saveDraftMode &&
            (isDraftForm || isPublishedForm)
        ) {
            <wdx-badge
                [themeColor]="
                    $any(
                        (isDraftForm && 'info') ||
                            (isPublishedForm && 'success')
                    )
                "
                data-cy="form-status"
            >
                {{ formDataStatus | translateTokenisedString }}
            </wdx-badge>
        }

        @if (isPublishedForm) {
            <button
                class="ms-2"
                wdxIconButton
                [wdxButton]="WdxButtonStyle.None"
                [ngbPopover]="
                    (showFormHistory
                        ? POPOVER_BACK_TO_FORM
                        : POPOVER_FORM_HISTORY
                    ) | translateTokenisedString
                "
                [triggers]="POP_UP_TRIGGER.triggers"
                [openDelay]="POP_UP_TRIGGER.openDelay"
                [closeDelay]="POP_UP_TRIGGER.closeDelay"
                (click)="toggleFormHistory()"
            >
                <wdx-icon
                    [icon]="showFormHistory ? ICON_BACK : ICON_FORM_HISTORY"
                ></wdx-icon>
            </button>
        }

        <ng-content select="[wdxFFCustomActions]"></ng-content>

        @if (
            formData?.actions
                | formActions: formStylingOptions?.hideCancelButton;
            as formActionButtons
        ) {
            @for (formActionButton of formActionButtons; track $index) {
                @if (formActionButton.dropdown?.length) {
                    <wdx-split-button
                        class="ms-2"
                        data-cy="form-split-action-button"
                        [isLoading]="isSaving"
                        [disabled]="
                            formActionButton.type !== 'Cancel' &&
                            (isSaving || fullFormLock)
                        "
                        [menuItems]="formActionButton.dropdown || []"
                        (menuItemClicked)="onFormAction($event)"
                    >
                        <ng-container
                            *ngTemplateOutlet="
                                btnTmpl;
                                context: { split: true }
                            "
                        ></ng-container>
                    </wdx-split-button>
                } @else {
                    <ng-container
                        *ngTemplateOutlet="btnTmpl; context: { split: false }"
                    ></ng-container>
                }

                <ng-template #btnTmpl let-split="split">
                    <button
                        [class.ms-2]="!split"
                        [attr.splitbutton]="split"
                        [attr.data-cy]="formActionButton.dataCy"
                        [wdxButton]="formActionButton.buttonStyle"
                        [disabled]="
                            formActionButton.type !== 'Cancel' &&
                            (isSaving || fullFormLock)
                        "
                        (click)="onFormAction(formActionButton)"
                    >
                        @if (formActionButton.type !== 'Cancel' && isSaving) {
                            <wdx-spinner [small]="true"></wdx-spinner>
                        }
                        {{ formActionButton.label }}
                    </button>
                </ng-template>
            }
        }
    </div>
</ng-template>

<!--
    using templates in this way may seem clunky, however ng-content elements cannot be controlled using
    simple @if or @switch logic as they will always be rendered, the docs state they need to be wrapped in
    templates to be truly conditional
 -->
<ng-template #customSectionTmpl let-customContent="customContent">
    @switch (customContent) {
        @case ('customContent0') {
            <ng-container *ngTemplateOutlet="customContent0"></ng-container>
        }
        @case ('customContent1') {
            <ng-container *ngTemplateOutlet="customContent1"></ng-container>
        }
        @case ('customContent2') {
            <ng-container *ngTemplateOutlet="customContent2"></ng-container>
        }
        @case ('customContent3') {
            <ng-container *ngTemplateOutlet="customContent3"></ng-container>
        }
        @case ('customContent4') {
            <ng-container *ngTemplateOutlet="customContent4"></ng-container>
        }
    }
</ng-template>

<ng-template #customContent0>
    <ng-content select="[wdxFFCustomContent0]" />
</ng-template>
<ng-template #customContent1>
    <ng-content select="[wdxFFCustomContent1]" />
</ng-template>
<ng-template #customContent2>
    <ng-content select="[wdxFFCustomContent2]" />
</ng-template>
<ng-template #customContent3>
    <ng-content select="[wdxFFCustomContent3]" />
</ng-template>
<ng-template #customContent4>
    <ng-content select="[wdxFFCustomContent4]" />
</ng-template>
